const toastr = require('toastr')

/**
 * トーストを表示させる。
 * @param target {jQuery|null} - jQueryオブジェクト。指定しない場合は、#notifications p要素を対象とする。
 */
export function showNotifications(target = null) {
    toastr.options.timeOut = 1500;
    toastr.options.positionClass = "toast-top-center";

    const notifications = target || $("#notifications p");

    notifications.each(function () {
        if ($(this).hasClass("notice") || $(this).hasClass("success")) {
            toastr.success($(this).text());
        } else {
            toastr.options.timeOut = 20000;
            toastr.options.closeButton = true;
            toastr.error($(this).text());
        }
    });
}

$(function() {
    showNotifications();
});

// turboでのリクエストが正常終了した際に実行される
$(document).on('turbo:frame-render', (event) => {
    if (event.target) {
        // トーストを表示させる
        showNotifications($(event.target).find('.notifications_turbo_frame p'));
    }
});
